export default __webpack_public_path__ + "static/media/page-not-found.9e4ee96e.png";